import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { ParsedRouteDefinition } from '../interfaces';

export const useKMLQuery = () => {
  const queryKey = ['kml'];

  const queryFn = () => Promise.resolve<ParsedRouteDefinition | null>(null);

  return useQuery({
    queryKey,
    queryFn,
    cacheTime: 1000 * 60 * 60 * 24, // 24h
    staleTime: 1000 * 60 * 60 * 24, // 24h
    refetchOnWindowFocus: false,
  });
};

export const useKMLFilename = () => {
  const queryKey = ['kmlFilename'];

  const queryFn = () => Promise.resolve<string | null>(null);

  return useQuery({
    queryKey,
    queryFn,
    cacheTime: 1000 * 60 * 60 * 24, // 24h
    staleTime: 1000 * 60 * 60 * 24, // 24h
    refetchOnWindowFocus: false,
  });
};

/**
 *
 * @param kml KML file contents to put into cache
 *
 * @description Use this once local KML file is loaded, to access it in all instances
 * of the map / street view components.
 */
export const setKMLqueryData = (prd: ParsedRouteDefinition) => {
  // Put data (or partial data) into cache
  queryClient.setQueryData(['kml'], prd);
};

/**
 *
 * @param kml KML file contents to put into cache
 *
 * @description Use this once local KML file is loaded, to access it in all instances
 * of the map / street view components.
 */
export const setKMLfilename = (name: string) => {
  queryClient.setQueryData(['kmlFilename'], name);
};
